var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{staticClass:"rounded-0 px-7 menu-btn",attrs:{"text":"","height":"100%","to":_vm.route,"exact":"","active-class":"menu-btn-active"}},[_c('span',{staticClass:"menu-btn-caption"},[_vm._v(_vm._s(_vm.title))])])}
var staticRenderFns = []

export { render, staticRenderFns }